import React from 'react';

const MileProfileFinder = ({ dataObj, getColorCode, createdAt, userName }) => {


  return (

    <>
      <main className="py-10 space-y-10 bg-white">
        <section className="flex flex-col space-y-10 ">
          <div className="flex flex-col space-y-8 text-left">
            <div className="flex justify-start items-start pt-2 pl-28">
              <img src="/img/logo/mile_logo.png" alt="Logo" className="w-56" />
            </div>
            <div className="py-2 space-y-4 text-left pl-28">
              <h1 className="text-6xl text-gray-900 font-bold text-left items-center justify-center">GENOME <span className="text-gray-900 font-medium">REPORT</span></h1>
              <h1 className="text-lg font-semibold text-[#009688]">Understanding how you naturally access focus, <br /> engagement, and peak performance.</h1>
            </div>
            <div className="flex justify-center pt-6">
              <img src="/userdashboard/flow-profile.png" alt="flow-profile" className="w-full h-full mx-auto" />
            </div>

            <div className="text-left pl-32 pt-12">
              <h2 className="flex items-center space-x-4 text-lg text-gray-900">
                <span className='w-12 font-bold'>Name:</span>
                <span className='font-medium'>{userName}</span>
              </h2>
              <h2 className="flex items-center space-x-4 text-lg text-gray-900">
                <span className='w-12 font-bold'>Date:</span>
                <span className='font-medium'>{createdAt}</span>
              </h2>
            </div>
            <div className="text-left pl-32 pt-12">
              <p className="text-lg text-[#212121] font-medium">Pitstop Consultancy Pvt. Lts. Online Assessments Copyright 2026</p>
              <p className="text-base font-medium text-[#212121]/70 italic">This report is confidential and should not be distributed without permission</p>
            </div>
          </div>
        </section>
      </main>

      <main className="p-10 px-6 space-y-5 bg-white">
        <div className="px-12 space-y-5 page-break">

          <div className="flex items-center justify-between w-full pt-4 pb-2 border-b italic text-[#212121]/85">
            <h1 className="text-lg font-semibold tracking-tight text-gray-900">Genome Report</h1>
            <p className="text-lg font-semibold">{userName} | {createdAt}</p>
          </div>

          <header className="mb-6">
            <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-gray-900">Executive Performance Coaching</h1>
            <p className="text-sm sm:text-base font-normal text-[#6B7280] pt-1">
              Flow Performance Science • Leadership • Peak Performance
            </p>
          </header>

          <div className="pt-2">
            <h2 className="text-lg font-semibold uppercase tracking-wider text-[#1E2530] pb-4">OPERATING SIGNATURE • TALENTPLUS + FLOW GENOME</h2>
            <div className="border border-slate-300 rounded-xl bg-[#FAFAFC] p-6 sm:p-8 shadow-sm mb-10">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 rounded-xl border border-slate-200 bg-white flex items-center justify-center shrink-0 shadow-2xs">
                  <svg className="w-10 h-10 text-slate-500" fill="currentColor" viewBox="0 0 24 24">  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" /></svg>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-[#1E2530] leading-tight">{userName}</h3>
                  <p className="text-sm font-medium text-[#6B7280]">
                    Executive Performance Coach
                  </p>
                </div>
              </div>

              {/* Metrics Grid */}
              <div className="flex items-center justify-between gap-6 sm:gap-4 py-4 mb-5">

                <div className={"border-l-4 pl-4 " + getColorCode(dataObj["primaryName"], "borderColor")}>
                  <span className="block text-base uppercase font-semibold text-gray-600">Primary</span>
                  <div className="pb-3">
                    <span className={"text-xl font-bold " + getColorCode(dataObj["primaryName"], "textColor")}>{dataObj["primaryName"]}</span>
                  </div>
                  <span className="block text-3xl font-bold text-[#212121]">{dataObj["primaryScore"]}</span>
                </div>

                {/* Secondary Column */}
                <div className={"border-l-4 pl-4 " + getColorCode(dataObj["secondaryName"], "borderColor")}>
                  <span className="block text-base uppercase font-semibold text-gray-600">Secondary</span>
                  <div className="pb-3">
                    <span className={"text-xl font-bold " + getColorCode(dataObj["secondaryName"], "textColor")}>{dataObj["secondaryName"]}</span>
                  </div>
                  <span className="block text-3xl font-bold text-[#212121]">{dataObj["secondaryScore"]}</span>
                </div>

                {/* Blend Within Column */}
                <div className="border-l-4 pl-4 border-gray-900">
                  <span className="block text-base uppercase font-semibold text-gray-600">BLEND WITH</span>
                  <div className="pb-3 whitespace-nowrap">
                    <span className="text-xl font-bold whitespace-nowrap text-gray-900">{dataObj?.["primaryName"] ?? ""} + {dataObj?.["secondaryName"] ?? ""}</span>
                  </div>
                  <span className="block text-3xl font-bold text-[#212121]">{(dataObj["primaryScore"] - dataObj["secondaryScore"]).toFixed(2)} points</span>
                </div>
              </div>

              <p className="text-lg text-gray-700 border-gray-400"
                style={{ fontFamily: "Arial, sans-serif", fontSize: "14px", lineHeight: "1.6", fontStyle: "italic", margin: 0, }}>
                <span style={{ fontWeight: 700, fontStyle: "italic", }}>{dataObj["primaryName"]}{" - "}{dataObj["secondaryName"]} coach</span>
                <span style={{ fontWeight: 400, fontStyle: "italic", }}>
                  {" - designs the operating model, then coaches the leader to inhabit it."}
                </span>
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h3 className="text-2xl font-bold uppercase tracking-wider text-gray-900 mb-4 border-orange-500">Profile blend</h3>
            <p className="text-base text-gray-700" style={{ lineHeight: "22px", margin: 0, }}>
              <span className="text-gray-800" style={{ fontWeight: 700 }}>
                Primary {dataObj["primaryName"]} ({dataObj["primaryScore"]}), Secondary {dataObj["secondaryName"]} ({dataObj["secondaryScore"]})
              </span>
              <span className="text-base text-gray-900 leading-relaxed">
                {" - "}{dataObj["blendSummary"] || ""}
              </span>
            </p>
          </div>
        </div>
      </main>


      <main className="p-10 px-6 space-y-5 bg-white">
        <div className="px-12 space-y-5 page-break">

          <div className="flex items-center justify-between w-full pt-4 pb-2 border-b italic text-[#212121]/85">
            <h1 className="text-lg font-semibold tracking-tight text-gray-900">Genome Report</h1>
            <p className="text-lg font-semibold">{userName} | {createdAt}</p>
          </div>

          <header>
            <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-gray-900">Executive Performance Coaching</h1>
            <p className="text-sm font-normal text-[#6B7280] pt-1">Flow Performance Science • Leadership • Peak Performance</p>
          </header>

          <div>
            <h2 className="text-2xl font-bold uppercase tracking-wide text-[#1E2530] pb-3">TALENT-TO-ROLE BRIDGE</h2>
            <div className={"border-l-4 pl-4 p-5 sm:p-6 flex justify-between items-center mb-8 rounded-r-xs " + getColorCode(dataObj["primaryName"], "borderColor") + " " + getColorCode(dataObj["primaryName"], "bgColor")}>
              <div>
                <span className="block text-xs font-bold uppercase tracking-wider text-gray-600 mb-1">PRIMARY TALENT SIGNATURE</span>
                <span className={"text-2xl sm:text-3xl font-bold " + getColorCode(dataObj["primaryName"], "textColor")}>{dataObj?.["primaryName"] ?? ""}</span>
              </div>
              <div className="text-right">
                <span className="block text-3xl font-bold text-[#1E2530] leading-none">{dataObj?.["primaryScore"] ?? ""}</span>
                <span className="block text-sm uppercase tracking-wider text-gray-700 mt-1">SCORE</span>
              </div>
            </div>
          </div>

          <section>
            <h3 className="text-lg font-bold uppercase tracking-wide text-[#1E2530] mb-2">HOW IT SHOWS UP AT WORK</h3>
            <p className="text-sm text-[#2C3E50] leading-relaxed text-justify sm:text-left"> {dataObj?.["primaryBridgeWork"] ?? ""}</p>
          </section>

          <section>
            <h3 className="text-lg font-bold uppercase tracking-wide text-[#1E2530] mb-3">ROLE FAMILIES WHERE IT COMPOUNDS</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-4 relative text-sm font-medium text-[#2C3E50]">
              {/* Central Divider Line */}
              <div className="hidden md:block absolute top-0 bottom-0 left-1/2 w-[1px] bg-slate-200/80 -translate-x-1/2 pointer-events-none" />
              <div className="space-y-4">
                {(dataObj?.["primaryBridgeRole"] ?? [])
                  .slice(0, Math.ceil((dataObj?.["primaryBridgeRole"]?.length || 0) / 2))
                  .map((ele, index) => (
                    <div key={index} className="flex items-start">
                      <span className={"inline-block w-2 h-2 rounded-full mt-1.5 mr-3.5 shrink-0 " + getColorCode(dataObj["primaryName"], "barColor")} />
                      <span className="leading-snug">{ele}</span>
                    </div>
                  ))}
              </div>
              <div className="space-y-4">
                {(dataObj?.["primaryBridgeRole"] ?? [])
                  .slice(Math.ceil((dataObj?.["primaryBridgeRole"]?.length || 0) / 2))
                  .map((ele, index) => (
                    <div key={index} className="flex items-start">
                      <span className={"inline-block w-2 h-2 rounded-full mt-1.5 mr-3.5 shrink-0 " + getColorCode(dataObj["primaryName"], "barColor")} />
                      <span className="leading-snug">{ele}</span>
                    </div>
                  ))}
              </div>
            </div>
          </section>
        </div>
      </main>

      <main className="p-10 px-6 space-y-5 bg-white">
        <div className="px-12 space-y-5 page-break">

          <div className="flex items-center justify-between w-full pt-4 pb-2 border-b italic text-[#212121]/85">
            <h1 className="text-lg font-semibold tracking-tight text-gray-900">Genome Report</h1>
            <p className="text-lg font-semibold">{userName} | {createdAt}</p>
          </div>

          <header>
            <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-gray-900">Executive Performance Coaching</h1>
            <p className="text-sm font-normal text-[#6B7280] pt-1">Flow Performance Science • Leadership • Peak Performance</p>
          </header>

          <div>
            <h2 className="text-2xl font-bold uppercase tracking-wide text-[#1E2530] pb-3">TALENT-TO-ROLE BRIDGE</h2>
            <div className={"border-l-4 pl-4 p-5 sm:p-6 flex justify-between items-center mb-8 rounded-r-xs " + getColorCode(dataObj["secondaryName"], "borderColor") + " " + getColorCode(dataObj["secondaryName"], "bgColor")}>
              <div>
                <span className="block text-xs font-bold uppercase tracking-wider text-gray-600 mb-1">PRIMARY TALENT SIGNATURE</span>
                <span className={"text-2xl sm:text-3xl font-bold " + getColorCode(dataObj["secondaryName"], "textColor")}>{dataObj?.["secondaryName"] ?? ""}</span>
              </div>
              <div className="text-right">
                <span className="block text-3xl font-bold text-[#1E2530] leading-none">{dataObj?.["secondaryScore"] ?? ""}</span>
                <span className="block text-sm uppercase tracking-wider text-gray-700 mt-1">SCORE</span>
              </div>
            </div>
          </div>

          <section>
            <h3 className="text-lg font-bold uppercase tracking-wide text-[#1E2530] mb-2">HOW IT SHOWS UP AT WORK</h3>
            <p className="text-sm text-[#2C3E50] leading-relaxed text-justify sm:text-left">{dataObj?.["secondaryBridgeWork"] ?? ""}</p>
          </section>

          <section>
            <h3 className="text-lg font-bold uppercase tracking-wide text-[#1E2530] mb-3">ROLE FAMILIES WHERE IT COMPOUNDS</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-4 relative text-sm font-medium text-[#2C3E50]">
              {/* Central Divider Line */}
              <div className="hidden md:block absolute top-0 bottom-0 left-1/2 w-[1px] bg-slate-200/80 -translate-x-1/2" />
              <div className="space-y-4">
                {(dataObj?.["secondaryBridgeRole"] ?? [])
                  .slice(0, Math.ceil((dataObj?.["secondaryBridgeRole"]?.length || 0) / 2))
                  .map((ele, index) => (
                    <div key={index} className="flex items-start">
                      <span className={"inline-block w-2 h-2 rounded-full mt-1.5 mr-3.5 shrink-0 " + getColorCode(dataObj["secondaryName"], "barColor")} />
                      <span className="leading-snug">{ele}</span>
                    </div>
                  ))}
              </div>
              <div className="space-y-4">
                {(dataObj?.["secondaryBridgeRole"] ?? [])
                  .slice(Math.ceil((dataObj?.["secondaryBridgeRole"]?.length || 0) / 2))
                  .map((ele, index) => (
                    <div key={index} className="flex items-start">
                      <span className={"inline-block w-2 h-2 rounded-full mt-1.5 mr-3.5 shrink-0 " + getColorCode(dataObj["secondaryName"], "barColor")} />
                      <span className="leading-snug">{ele}</span>
                    </div>
                  ))}
              </div>
            </div>
          </section>
        </div>
      </main>

      <main className="p-10 px-6 space-y-5 bg-white">
        <div className="px-12 space-y-5 page-break">

          <div className="flex items-center justify-between w-full pt-4 pb-2 border-b italic text-[#212121]/85">
            <h1 className="text-lg font-semibold tracking-tight text-gray-900">Genome Report</h1>
            <p className="text-lg font-semibold">{userName} | {createdAt}</p>
          </div>

          <header>
            <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-gray-900">Executive Performance Coaching</h1>
            <p className="text-sm font-normal text-[#6B7280] pt-1">Flow Performance Science • Leadership • Peak Performance</p>
          </header>

          <div>
            <h2 className="text-2xl font-bold uppercase tracking-wide text-[#1E2530] pb-3">TALENT-TO-ROLE BRIDGE</h2>
            <div className={"border-l-4 pl-4 p-5 sm:p-6 flex justify-between items-center mb-8 rounded-r-xs " + getColorCode(dataObj["secondaryName"], "borderColor") + " " + getColorCode(dataObj["secondaryName"], "bgColor")}>
              <div>
                <span className="block text-xs font-bold uppercase tracking-wider text-gray-600 mb-1">PRIMARY TALENT SIGNATURE</span>
                <span className={"text-2xl sm:text-3xl font-bold " + getColorCode(dataObj["secondaryName"], "textColor")}>{dataObj?.["secondaryName"] ?? ""}</span>
              </div>
              <div className="text-right">
                <span className="block text-3xl font-bold text-[#1E2530] leading-none">{dataObj?.["secondaryScore"] ?? ""}</span>
                <span className="block text-sm uppercase tracking-wider text-gray-700 mt-1">SCORE</span>
              </div>
            </div>
          </div>

          <section>
            <h3 className="text-lg font-bold uppercase tracking-wide text-[#1E2530] mb-2">HOW IT SHOWS UP AT WORK</h3>
            <p className="text-sm text-[#2C3E50] leading-relaxed text-justify sm:text-left">{dataObj?.["secondaryBridgeWork"] ?? ""}</p>
          </section>

          <section>
            <h3 className="text-lg font-bold uppercase tracking-wide text-[#1E2530] mb-3">ROLE FAMILIES WHERE IT COMPOUNDS</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-4 relative text-sm font-medium text-[#2C3E50]">
              {/* Central Divider Line */}
              <div className="hidden md:block absolute top-0 bottom-0 left-1/2 w-[1px] bg-slate-200/80 -translate-x-1/2" />
              <div className="space-y-4">
                {(dataObj?.["secondaryBridgeRole"] ?? [])
                  .slice(0, Math.ceil((dataObj?.["secondaryBridgeRole"]?.length || 0) / 2))
                  .map((ele, index) => (
                    <div key={index} className="flex items-start">
                      <span className={"inline-block w-2 h-2 rounded-full mt-1.5 mr-3.5 shrink-0 " + getColorCode(dataObj["secondaryName"], "barColor")} />
                      <span className="leading-snug">{ele}</span>
                    </div>
                  ))}
              </div>
              <div className="space-y-4">
                {(dataObj?.["secondaryBridgeRole"] ?? [])
                  .slice(Math.ceil((dataObj?.["secondaryBridgeRole"]?.length || 0) / 2))
                  .map((ele, index) => (
                    <div key={index} className="flex items-start">
                      <span className={"inline-block w-2 h-2 rounded-full mt-1.5 mr-3.5 shrink-0 " + getColorCode(dataObj["secondaryName"], "barColor")} />
                      <span className="leading-snug">{ele}</span>
                    </div>
                  ))}
              </div>
            </div>
          </section>
        </div>
      </main>

      <main className="p-10 px-6 space-y-5 bg-white">
        <div className="px-12 space-y-5 page-break">

          <div className="flex items-center justify-between w-full pt-4 pb-2 border-b italic text-[#212121]/85">
            <h1 className="text-lg font-semibold tracking-tight text-gray-900">Genome Report</h1>
            <p className="text-lg font-semibold">{userName} | {createdAt}</p>
          </div>

          <header>
            <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-gray-900">Executive Performance Coaching</h1>
            <p className="text-sm font-normal text-[#6B7280] pt-1">Flow Performance Science • Leadership • Peak Performance</p>
          </header>

          <div>
            <h2 className="text-2xl font-bold uppercase tracking-wide text-[#1E2530] pb-3">TALENT-TO-ROLE BRIDGE</h2>
            <div className="border-l-4 border-gray-900 bg-gray-900/10 pl-4 p-5 sm:p-6 flex justify-between items-center mb-8 rounded-r-xs">
              <div className="flex flex-col">
                <span className="block text-xs font-bold uppercase tracking-wider text-gray-600 mb-1">Blend Talent Signature</span>
                <span className="text-2xl sm:text-3xl font-bold text-gray-900">{dataObj?.["primaryName"] ?? ""} + {dataObj?.["secondaryName"] ?? ""}</span>
                <span className="mt-2 text-xs text-gray-900 italic">Only emerges when both talents fire together</span>
              </div>
              <div className="text-right">
                {/* <span className="block text-3xl font-bold text-[#1E2530] leading-none">{(dataObj["primaryScore"] - dataObj["secondaryScore"]).toFixed(2)}</span> */}
                {/* <span className="block text-sm uppercase tracking-wider text-gray-700 mt-1">SCORE</span> */}
              </div>
            </div>
          </div>

          <section>
            <h3 className="text-lg font-bold uppercase tracking-wide text-[#1E2530] mb-4">HOW IT SHOWS UP AT WORK</h3>
            <p className="text-base font-bold uppercase tracking-wider text-gray-500 mb-1">Profile Snapshot</p>
            <p className="text-sm text-[#2C3E50] leading-relaxed text-justify sm:text-left">{dataObj?.["blendBridgeContent"]?.workSummary?.snapshots ?? ""}</p>
          </section>

          <section>
            <h3 className="text-lg font-bold uppercase tracking-wide text-[#1E2530] mb-3">Role Fit</h3>
            <div className="text-base font-bold uppercase tracking-wider text-gray-500 mb-1">
              Core Orientation
            </div>
            <div className="text-sm text-gray-700 leading-relaxed">
              {dataObj?.["blendBridgeContent"]?.roleSummary?.core ?? ""}
            </div>

            <h3 className="text-lg font-bold uppercase tracking-wide text-[#1E2530] my-6">Good-Fit Roles</h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-4 relative text-sm font-medium text-[#2C3E50]">
              <div className="hidden md:block absolute top-0 bottom-0 left-1/2 w-[1px] bg-slate-200/80 -translate-x-1/2" />
              <div className="space-y-4">
                {(dataObj?.blendBridgeContent?.roleSummary?.role ?? [])
                  .slice(0, Math.ceil((dataObj?.blendBridgeContent?.roleSummary?.role?.length || 0) / 2))
                  .map((ele, index) => (
                    <div key={`left-${index}`} className="flex items-start">
                      <span className="inline-block w-2 h-2 rounded-full bg-gray-900 mt-1.5 mr-3.5 shrink-0" />
                      <span className="leading-snug">{ele}</span>
                    </div>
                  ))}
              </div>
              <div className="space-y-4">
                {(dataObj?.blendBridgeContent?.roleSummary?.role ?? [])
                  .slice(Math.ceil((dataObj?.blendBridgeContent?.roleSummary?.role?.length || 0) / 2))
                  .map((ele, index) => (
                    <div key={`right-${index}`} className="flex items-start">
                      <span className="inline-block w-2 h-2 rounded-full bg-gray-900 mt-1.5 mr-3.5 shrink-0" />
                      <span className="leading-snug">{ele}</span>
                    </div>
                  ))}
              </div>
            </div>
          </section>
        </div>
      </main>

    </>
  );
};

export default MileProfileFinder;